import {FileSpreadsheet} from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';

export const chargeinformationBusinesstransactionsActionMenu: MenuAction[] = [
  {
    id: 'show',
    title: 'common.show',
    icon: FileSpreadsheet,
    disabled: true,
  }
];
